export const apiCreate = (): string => '/financial/operationIndexes/'
export const apiList = (id?: string): string =>
  !id
    ? '/financial/operationIndexes/'
    : `/financial/operationIndexes/view/${id}`
export const apiUpdate = (id: string): string =>
  `/financial/operationIndexes/update/${id}`
export const apiDelete = (id: string): string =>
  `/financial/operationIndexes/${id}`
